export default "/static/nikon_ti2e_tiny.png";